export default __webpack_public_path__ + "static/media/logo.99bee472.png";